import React from 'react';
import Base from './Base';

const CookiesButton = (props) => <Base {...props} className="btn--cookies" />;

export default CookiesButton;
